import React from 'react';
import './products.css';

function Products({ imageUrl, logoUrl, title, info, linkUrl }) {
  const cardContent = (
    <>
      <img className='img' src={imageUrl} alt={title} />
      <div className='middle'>
        {logoUrl && <img className='productLogo' src={logoUrl} alt={`${title} logo`} />}
        <h1>{title}</h1>
        <h4>{info}</h4>
      </div>
    </>
  );

  if (linkUrl) {
    return (
      <div className='products'>
        <a className='productblock productLink' href={linkUrl} target='_blank' rel='noreferrer'>
          {cardContent}
        </a>
      </div>
    );
  }

  return (
    <div className='products'>
      <div className='productblock'>
        {cardContent}
      </div>
    </div>
  );
}

export default Products;